import { generateAutomationName } from "app/pages/activation/helpers/generateAutomationName";

export const headerDataAutomation = {
    container: generateAutomationName("home", ["header", "container"]),
    userName: generateAutomationName("home", ["header", "user", "name"]),
    actionsContainer: generateAutomationName("home", ["header", "actions", "container"]),
    usersIcon: generateAutomationName("home", ["header", "users", "icon"]),
    rocketIcon: generateAutomationName("home", ["header", "rocket", "icon"]),
    usersPackage: generateAutomationName("home", ["header", "users", "package"]),
};

export const searchBarDataAutomation = {
    container: generateAutomationName("home", ["search-bar", "container"]),
    title: generateAutomationName("home", ["search-bar", "title"]),
    searchAutocomplete: generateAutomationName("home", ["search-bar", "search-autocomplete"]),
};

export const alertsDataAutomation = {
    container: generateAutomationName("home", ["alerts", "container"]),
    header: generateAutomationName("home", ["alerts", "header"]),
    title: generateAutomationName("home", ["alerts", "title"]),
    viewAllBtn: generateAutomationName("home", ["alerts", "view", "all", "button"]),
    emptyState: generateAutomationName("home", ["alerts", "empty", "state", "container"]),
    emptyStateImg: generateAutomationName("home", ["alerts", "empty", "state", "img"]),
    emptyStateText: generateAutomationName("home", ["alerts", "empty", "state", "text"]),
    itemsContainer: generateAutomationName("home", ["alerts", "items", "container"]),
    loadingItem: generateAutomationName("home", ["alerts", "loading", "item"]),
    noProjectsItem: generateAutomationName("home", ["alerts", "noProjects", "item"]),
    noProjectsCreateBtn: generateAutomationName("home", ["alerts", "noProjects", "create", "button"]),
    noProjectsContent: generateAutomationName("home", ["alerts", "noProjects", "content"]),
    itemContainer: generateAutomationName("home", ["alerts", "item", "container"]),
    itemContentContainer: generateAutomationName("home", ["alerts", "item", "content", "container"]),
    itemTitle: generateAutomationName("home", ["alerts", "item", "title"]),
    itemDescription: generateAutomationName("home", ["alerts", "item", "description"]),
};

export const projectsDataAutomation = {
    container: generateAutomationName("home", ["projects", "container"]),
    title: generateAutomationName("home", ["projects", "title"]),
    seeAllButton: generateAutomationName("home", ["projects", "see", "all", "button"]),
    createButton: generateAutomationName("home", ["projects", "create", "button"]),
    projectsContainer: generateAutomationName("home", ["projects", "items", "container"]),
    projectItem: (id: string) => generateAutomationName("home", ["projects", "items", "container", id]),
    emptyProjectItem: generateAutomationName("home", ["projects", "item", "container", "empty"]),
    loadingProjectItem: generateAutomationName("home", ["projects", "item", "container", "loading"]),
    itemName: generateAutomationName("home", ["projects", "item", "name"]),
    itemCompetitors: generateAutomationName("home", ["projects", "item", "competitors"]),
    itemIcons: generateAutomationName("home", ["projects", "item", "icons"]),
    itemIconButton: generateAutomationName("home", ["projects", "item", "icon", "button"]),
    viewProjectButton: generateAutomationName("home", ["projects", "item", "view", "project", "button"]),
};

export const recentActivityDataAutomation = {
    container: generateAutomationName("home", ["recent-activity", "container"]),
    title: generateAutomationName("home", ["recent-activity", "title"]),
    websiteItem: generateAutomationName("home", ["recent-activity", "website", "item", "container"]),
    keywordItem: generateAutomationName("home", ["recent-activity", "keyword", "item", "container"]),
    itemsContainer: generateAutomationName("home", ["recent-activity", "items", "container"]),
    itemIcon: generateAutomationName("home", ["recent-activity", "item", "icon"]),
    itemPage: generateAutomationName("home", ["recent-activity", "item", "page"]),
    itemSearchResults: generateAutomationName("home", ["recent-activity", "item", "search", "results"]),
};
export const shareDataAutomation = {};
